import { NgModule } from '@angular/core';
import { PopupsComponent } from './popups.component';
import { LevelStatusComponent } from './level-status/level-status.component';
import { CommonModule } from '@angular/common';
import { SharedModule, NgMaterialModule } from 'shared';
import { RouterModule } from '@angular/router';
import { PopupsRoutes } from './popups.routing';

@NgModule({
  declarations: [PopupsComponent, LevelStatusComponent],
  imports: [
    CommonModule,
    NgMaterialModule,
    SharedModule,
    RouterModule.forChild(PopupsRoutes)
  ],
  exports: [PopupsComponent, LevelStatusComponent]
})
export class PopupsModule { }
